/**
 * Vaste kamers: een gesprek zonder einddatum.
 *
 * GEEN EXTRA KOLOM, EN DAT IS EEN BESLUIT. Een vaste kamer krijgt als einddatum
 * 31 december 9999. Dan werken alle bestaande controles op "verlopen" - de
 * database-opruimer, actief(), leesBruikbaar() - zonder een regel extra, en is
 * er maar EEN bron van waarheid. Met een losse vlag ernaast kan "vast" zeggen
 * ja terwijl de einddatum morgen is, en dan weet niemand welke van de twee
 * wint.
 *
 * Een vaste kamer stopt alleen als de maker hem sluit (de prullenbak), of als
 * hij er weer een einddatum op zet.
 */

/** De einddatum van een vaste kamer, in ms sinds 1970. Past ruim in een getal. */
export const VAST_TOT = Date.UTC(9999, 11, 31);

/**
 * Hoe lang een bericht hoogstens bewaard blijft, in dagen.
 *
 * Geldt voor ELKE kamer, maar raakt in de praktijk alleen een vaste kamer: een
 * gewone kamer is hoogstens zeven dagen geldig en wordt een uur daarna met al
 * zijn berichten gewist. Besloten door Giovanni op 9 oktober 2026.
 */
export const BERICHTEN_BEWAAR_DAGEN = 30;

export function isVasteKamer(expiresAt: number): boolean {
  return expiresAt >= VAST_TOT;
}
